//@ts-ignore
import numfmt from 'numfmt';
numfmt.addLocale({
    group: '.',
    decimal: ',',
    mmmm: [
        'siječanj',
        'veljača',
        'ožujak',
        'travanj',
        'svibanj',
        'lipanj',
        'srpanj',
        'kolovoz',
        'rujan',
        'listopad',
        'studeni',
        'prosinac',
    ],
    mmm: ['sij', 'velj', 'ožu', 'tra', 'svi', 'lip', 'srp', 'kol', 'ruj', 'lis', 'stu', 'pro'],
    dddd: ['ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota', 'nedjelja'],
    ddd: ['pon', 'uto', 'sri', 'čet', 'pet'],
}, 'hr-HR');
/**
 * Converts JS Date to serial number (make sure to use UTC time)
 * @param date native JS Date object
 * @returns serial representation of date
 */
export function dateToSerial(date) {
    var converted = numfmt.dateToSerial(date, { ignoreTimezone: true });
    if (typeof converted === 'number') {
        return converted;
    }
    else {
        return null;
    }
}
/**
 * Converts serial number to JS Date (make sure to use UTC time)
 * @param serial serial representation of date
 * @returns native JS Date object
 */
export function serialToDate(serial) {
    var converted = numfmt.dateFromSerial(serial, { nativeDate: true });
    if (converted instanceof Date) {
        return converted;
    }
    else {
        return null;
    }
}
export function isExcelDateFormat(format) {
    return format ? numfmt(format).isDate() : false;
}
export function isExcelPercentFormat(format) {
    return format ? numfmt(format).isPercent() : false;
}
export function createNumberFormater(format, locale) {
    return numfmt(format, { locale: locale });
}
export function isValidFormat(format) {
    var valid = true;
    try {
        numfmt.format(format, 69420);
    }
    catch (error) {
        valid = false;
    }
    return valid;
}
export function parseNumberWithLocale(value, locale) {
    var result = numfmt.parseNumber(value, { locale: locale });
    // types give only object | null, but result can also be undefined
    if (result === null || result === undefined) {
        return null;
    }
    if (typeof result.v !== 'number' || Number.isNaN(result.v) || !Number.isFinite(result.v)) {
        return null;
    }
    return result.v;
}
